export const ItemType = {
  MATERIAL: 'Material',
  MIX: 'Mix',
  EXTRA: 'Extra',
};

export const AccountType = {
  Open: 'Open',
  Cod: 'Cod',
};
